import React, { useMemo } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Typography,
  Divider,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ReplyIcon from '@mui/icons-material/Reply';
import { useDirect } from '../DirectContext.js';
import { MEDIA_QUESTIONBOX } from '../data/constants.js';
import { deleteQuestionFromQuestionBox } from '../../../../../api/index.js';

export const DynamicObserver = ({ item, action }) => {

  console.log('DynamicObserver rendered with item & action:', item, action);

  const directEvent = useDirect();

  const observableItem = useMemo(() => {
    console.log('item in DynamicObserver:', item);
    console.log('directEveent questionBoxes:', directEvent.questionBoxes);

    switch (item.type) {
      case MEDIA_QUESTIONBOX:
        return directEvent.questionBoxes.find((q) => q._id === item._id);
      default:
        return null;
    }
  }, [directEvent, item]);

  const handleDelete = async (questionId) => {
    try {
      // Remplacez cette URL par celle de votre API de suppression
      deleteQuestionFromQuestionBox(observableItem._id, questionId)
      // Mettez à jour l'état local ou utilisez un mécanisme de rafraîchissement si nécessaire
    } catch (error) {
      console.error('Erreur lors de la suppression de la question:', error);
    }
  };

  console.log('observableItem.questions:', observableItem ? observableItem.questions : 'undefined');

  if (!observableItem || observableItem.questions?.length<1) {
    return <Typography>Aucune question disponible.</Typography>;
  }

  return (
    <Box
      sx={{
        maxHeight: 400,
        overflowY: 'auto',
        border: '1px solid #ccc',
        borderRadius: 2,
        p: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <List>
        {observableItem.questions.map((q, index) => (
          <React.Fragment key={q._id}>
            <ListItem alignItems="flex-start" sx={{ alignItems: 'flex-start', p : 0 }}>
              <ListItemText
                primary={
                  <Typography variant="subtitle1" fontWeight="bold">
                    {q.pseudo}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography variant="body2" color="textPrimary" sx={{
                                                                        pr: 9, // assez pour éviter de toucher les icônes (ajuste si besoin)
                                                                        textAlign: 'justify',
                                                                        textJustify: 'inter-word',
                                                                        hyphens: 'auto', // permet les coupures de mot naturelles
                                                                        wordBreak: 'break-word',
                                                                        overflowWrap: 'break-word'
                                                                      }}>
                      {q.question}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {new Date(q.datetime).toLocaleString('fr-FR', {
                        dateStyle: 'short',
                        timeStyle: 'short',
                      })}
                    </Typography>
                  </>
                }
              />
              <ListItemSecondaryAction sx={{ ml: 2 }}>
                <IconButton
                  edge="end"
                  aria-label="répondre"
                  onClick={() => action(q.pseudo, q.question)}
                >
                  <ReplyIcon />
                </IconButton>
                <IconButton
                  edge="end"
                  aria-label="supprimer"
                  onClick={() => handleDelete(q._id)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            {index < observableItem.questions.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};
